import { FETCH_GET } from "../../config";

export const FETCH_PRODUCTS_BY_CATEGORY_PENDING =
  "FETCH_PRODUCTS_BY_CATEGORY_PENDING";
export const FETCH_PRODUCTS_BY_CATEGORY_FULFILLED =
  "FETCH_PRODUCTS_BY_CATEGORY_FULFILLED";
export const FETCH_PRODUCTS_BY_CATEGORY_REJECTED =
  "FETCH_PRODUCTS_BY_CATEGORY_REJECTED";

export const SEARCH_PRODUCTS_BY_CATEGORY_PENDING =
  "SEARCH_PRODUCTS_BY_CATEGORY_PENDING";
export const SEARCH_PRODUCTS_BY_CATEGORY_FULFILLED =
  "SEARCH_PRODUCTS_BY_CATEGORY_FULFILLED";
export const SEARCH_PRODUCTS_BY_CATEGORY_REJECTED =
  "SEARCH_PRODUCTS_BY_CATEGORY_REJECTED";

export const FETCH_PRODUCT_BY_SLUG_PENDING = "FETCH_PRODUCT_BY_SLUG_PENDING";
export const FETCH_PRODUCT_BY_SLUG_FULFILLED =
  "FETCH_PRODUCT_BY_SLUG_FULFILLED";
export const FETCH_PRODUCT_BY_SLUG_REJECTED = "FETCH_PRODUCT_BY_SLUG_REJECTED";

export const SET_PRODUCT = "SET_PRODUCT";

export const FEATURED_PRODUCTS_PENDING = "FEATURED_PRODUCTS";
export const FEATURED_PRODUCTS_FULFILLED = "FEATURED_PRODUCTS_FULFILLED";
export const FEATURED_PRODUCTS_REJECTED = "FEATURED_PRODUCTS_REJECTED";

export const RECENTLY_ADDED_PRODUCTS_PENDING =
  "RECENTLY_ADDED_PRODUCTS_PENDING";
export const RECENTLY_ADDED_PRODUCTS_FULFILLED =
  "RECENTLY_ADDED_PRODUCTS_FULFILLED";
export const RECENTLY_ADDED_PRODUCTS_REJECTED =
  "RECENTLY_ADDED_PRODUCTS_REJECTED";

export const OTHER_PRODUCTS_PENDING = "OTHER_PRODUCTS_PENDING";
export const OTHER_PRODUCTS_FULFILLED = "OTHER_PRODUCTS_FULFILLED";
export const OTHER_PRODUCTS_REJECTED = "OTHER_PRODUCTS_REJECTED";

export const otherProducts = () => {
  const query = `query={otherProducts{id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: OTHER_PRODUCTS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: OTHER_PRODUCTS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: OTHER_PRODUCTS_FULFILLED,
          payload: result.data.data.otherProducts,
        });
      }
    } catch (e) {
      dispatch({ type: OTHER_PRODUCTS_REJECTED });
    }
  };
};

export const recentlyAddedProducts = () => {
  const query = `query={recentlyAddedProducts{id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: RECENTLY_ADDED_PRODUCTS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: RECENTLY_ADDED_PRODUCTS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: RECENTLY_ADDED_PRODUCTS_FULFILLED,
          payload: result.data.data.recentlyAddedProducts,
        });
      }
    } catch (e) {
      dispatch({ type: RECENTLY_ADDED_PRODUCTS_REJECTED });
    }
  };
};

export const featuredProducts = () => {
  const query = `query={featuredProducts{id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: FEATURED_PRODUCTS_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: FEATURED_PRODUCTS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FEATURED_PRODUCTS_FULFILLED,
          payload: result.data.data.featuredProducts,
        });
      }
    } catch (e) {
      dispatch({ type: FEATURED_PRODUCTS_REJECTED });
    }
  };
};

export const setProduct = (data, callback) => {
  return (dispatch) => {
    dispatch({
      type: SET_PRODUCT,
      payload: data,
    });
    callback(data.image);
  };
};

export const getProductBySlug = (slug, callback) => {
  const query = `query={getProductBySlug(slug:"${slug}"){id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: FETCH_PRODUCT_BY_SLUG_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: FETCH_PRODUCT_BY_SLUG_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_PRODUCT_BY_SLUG_FULFILLED,
          payload: result.data.data.getProductBySlug,
        });
        callback(result.data.data.getProductBySlug.image);
      }
    } catch (e) {
      dispatch({ type: FETCH_PRODUCT_BY_SLUG_REJECTED });
    }
  };
};

export const getProductsByCategory = (categoryID) => {
  const query = `query={getProductsByCategory(categoryID:"${categoryID}"){id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: FETCH_PRODUCTS_BY_CATEGORY_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: FETCH_PRODUCTS_BY_CATEGORY_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_PRODUCTS_BY_CATEGORY_FULFILLED,
          payload: result.data.data.getProductsByCategory,
        });
      }
    } catch (e) {
      dispatch({ type: FETCH_PRODUCTS_BY_CATEGORY_REJECTED });
    }
  };
};

export const searchProduct = (q) => {
  const query = `query={searchProduct(query:"${q}"){id,name,
    content,
    meta_title,
    meta_description,
    meta_keywords,
    active,
    categories{id,title,slug,discount{percent,price}},
    image,
    images,
    stock,
    price,
    sale_price,
    stock_status,
    shipping,
    shipping_price,
    slug,
    featured,
    online_shopping{key,url}}}`;
  return async (dispatch) => {
    dispatch({ type: SEARCH_PRODUCTS_BY_CATEGORY_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: SEARCH_PRODUCTS_BY_CATEGORY_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: SEARCH_PRODUCTS_BY_CATEGORY_FULFILLED,
          payload: result.data.data.searchProduct,
        });
      }
    } catch (e) {
      dispatch({ type: SEARCH_PRODUCTS_BY_CATEGORY_REJECTED });
    }
  };
};

// export const getProduct = ({ id }) => {
//   const query = `query={getProduct(id:"${id}"){id,name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories{id,title},
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price}}`;
//   return async (dispatch, getState) => {
//     dispatch({ type: FETCH_PRODUCT_PENDING });
//     const data = getState().product.productList.find(v => v.id === id);
//     if (data) {
//       dispatch({
//         type: FETCH_PRODUCT_FULFILLED,
//         payload: data
//       });
//     } else {
//       try {
//         const result = await FETCH_GET(query);
//         if (result.data.errors) {
//           dispatch(
//             addFlashMessage({
//               type: "danger",
//               title: "Bir Hata Meydana Geldi",
//               messages: result.data.errors.map(v => v.message)
//             })
//           );
//           dispatch({
//             type: FETCH_PRODUCT_REJECTED,
//             payload: result.data.errors
//           });
//         } else {
//           dispatch({
//             type: FETCH_PRODUCT_FULFILLED,
//             payload: result.data.data.getProduct
//           });
//         }
//       } catch (e) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: [e.toString()]
//           })
//         );
//         dispatch({ type: FETCH_PRODUCT_REJECTED });
//       }
//     }
//   };
// };
//
// export const fetchAllProducts = () => {
//   const query = `query={allProducts{
//     id,name,
//     content,
//     meta_title,
//     meta_description,
//     meta_keywords,
//     active,
//     categories{id,title},
//     image,
//     images,
//     stock,
//     price,
//     sale_price,
//     stock_status,
//     shipping,
//     shipping_price
//   }}`;
//   return async dispatch => {
//     dispatch({ type: FETCH_ALL_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_GET(query);
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: FETCH_ALL_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: FETCH_ALL_PRODUCT_FULFILLED,
//           payload: result.data.data.allProducts
//         });
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: FETCH_ALL_PRODUCT_REJECTED });
//     }
//   };
// };
//
// export const deleteProduct = ({ id }) => {
//   const query = `mutation($id:ID!){deleteProduct(id:$id)}`;
//   const variables = JSON.stringify({ id });
//
//   return async dispatch => {
//     dispatch({ type: DELETE_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_POST({ query, variables });
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi1",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: DELETE_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: DELETE_PRODUCT_FULFILLED,
//           payload: id
//         });
//         dispatch(
//           push({
//             pathname: "/products",
//             state: {
//               flashMessage: {
//                 type: "success",
//                 title: "Başarıyla Silindi"
//               }
//             }
//           })
//         );
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi2",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: DELETE_PRODUCT_REJECTED });
//     }
//   };
// };
//
// export const createProduct = ({
//   name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories,
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price
// }) => {
//   const query = `mutation($input:createProductInput){createProduct(input:$input){id,name,
//   content,
//   meta_title,
//   meta_description,
//   meta_keywords,
//   active,
//   categories{id,title},
//   image,
//   images,
//   stock,
//   price,
//   sale_price,
//   stock_status,
//   shipping,
//   shipping_price}}`;
//   const variables = JSON.stringify({
//     input: {
//       name,
//       content,
//       meta_title,
//       meta_description,
//       meta_keywords,
//       active,
//       categories,
//       image,
//       images,
//       stock,
//       price,
//       sale_price,
//       stock_status,
//       shipping,
//       shipping_price
//     }
//   });
//
//   return async dispatch => {
//     dispatch({ type: CREATE_PRODUCT_PENDING });
//     try {
//       const result = await FETCH_POST({ query, variables });
//       if (result.data.errors) {
//         dispatch(
//           addFlashMessage({
//             type: "danger",
//             title: "Bir Hata Meydana Geldi",
//             messages: result.data.errors.map(v => v.message)
//           })
//         );
//         dispatch({
//           type: CREATE_PRODUCT_REJECTED,
//           payload: result.data.errors
//         });
//       } else {
//         dispatch({
//           type: CREATE_PRODUCT_FULFILLED,
//           payload: result.data.data.createProduct
//         });
//         dispatch(
//           push({
//             pathname: "/products",
//             state: {
//               flashMessage: {
//                 type: "success",
//                 title: "Başarıyla Kaydedildi"
//               }
//             }
//           })
//         );
//       }
//     } catch (e) {
//       dispatch(
//         addFlashMessage({
//           type: "danger",
//           title: "Bir Hata Meydana Geldi",
//           messages: [e.toString()]
//         })
//       );
//       dispatch({ type: CREATE_PRODUCT_REJECTED });
//     }
//   };
// };



// WEBPACK FOOTER //
// ./src/store/actions/product.js